import { useState, useEffect } from "react";
import { isDemoMode } from "../firebase";
import { DEMO_USER } from "../demoData";
import { saveProfile, subscribePrivateProfile } from "../lib/profileStore";

export function useProfile(uid) {
  const [profile, setProfile] = useState(isDemoMode ? DEMO_USER : null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isDemoMode || !uid) return;
    setLoading(true);
    setError(null);
    return subscribePrivateProfile(
      uid,
      (nextProfile) => {
        setProfile(nextProfile);
        setLoading(false);
      },
      (nextError) => {
        setError(nextError);
        setLoading(false);
      }
    );
  }, [uid]);

  const updateProfile = async (data) => {
    if (isDemoMode || !uid) return;
    return saveProfile(uid, data);
  };

  return { profile, loading, error, updateProfile };
}
